module.exports = __webpack_public_path__ + "static/img/clix.75e3a95.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/enroll/hero/clix.png
// module id = 8NGf
// module chunks = 35